import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {FS3ValidationResult} from "../../../objects/validationResult";
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {ListItem} from "../../../objects/listItem";
import {SharedDataService} from "../../../services/shared-data.service";
import {environment} from "../../../../environments/environment";
import {FS3Notification} from "../../../objects/notification";
import {AppEvent} from "../../../objects/appEvent";
import {DialogCanvasComponent} from "../../dialog-canvas/dialog-canvas.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";

@Component({
  selector: 'app-group-create-form',
  templateUrl: './group-create-form.component.html',
  styleUrls: ['../mobile-container/mobile-container.component.scss']
})
export class GroupCreateFormComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() success = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  private formValidationMessages = {
    required: 'Value required.',
  };
  public validationResult: FS3ValidationResult;
  public componentForm: FormGroup = new FormGroup({});
  public textInput: FormControl = new FormControl('', [Validators.required, this.formValidator()]);
  //public privacyInput: FormControl = new FormControl('');
  public groupType: FormControl = new FormControl('');
  public privacyCheck: FormControl = new FormControl('');
  state: string = 'edit';
  errMsg: string = '';
  public listItem: ListItem;

  public picture_src_icon: string;
  public picture_src_ava: string;
  public picture_src_preview: string;
  public aspect_ratio: number;

  constructor(public dialog: MatDialog,
              private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.listItem = this.payload['item'];
    this.componentForm.addControl('textInput', this.textInput);
    //this.componentForm.addControl('privacyInput', this.privacyInput);
    this.componentForm.addControl('groupType', this.groupType);
    this.componentForm.addControl('privacyCheck', this.privacyCheck);

    if(!this.listItem) { //new
      //.privacyInput.setValue('confirmation')
      this.groupType.setValue('smart_class');
      this.privacyCheck.setValue(true)
    } else {
      let config = this.listItem['itemFullData']['payload_parsed'];
      this.textInput.setValue(this.listItem.name)
      //this.privacyInput.setValue(config['privacy'])
      this.groupType.setValue(config['type']);
      this.privacyCheck.setValue(config['privacy'] === 'confirmation');
      this.picture_src_icon = this.listItem['itemFullData']['picture_src_icon'];
      this.picture_src_ava = this.listItem['itemFullData']['picture_src_ava'];
      this.picture_src_preview = this.listItem['itemFullData']['picture_src_preview'];
    }
  }

  public handleSubmit(event: Event | void = null): boolean {
    if (event) {
      event.stopPropagation();
    }

    if (!this.textInput.valid) {
      this.textInput.markAsTouched()
      const errorKey = Object.keys(this.textInput.errors)[0]; // get error key from input errors
      this.validationResult = {
        isValid: false,
        message: this.textInput.errors[errorKey] // get error string by errorKey
      };
      return false;
    } else {
      this.validationResult = null; //hide validationResult leftovers
    }

    this.updateGroup();
    this.state = 'loading';

    return false
  }

  private updateGroup() {
    let configToSave = {
      label: this.textInput.value,
      type: this.groupType.value,
      privacy: this.privacyCheck.value ? 'confirmation' : 'public',
      picture_src_ava: this.picture_src_ava,
      picture_src_icon: this.picture_src_icon,
      picture_src_preview: this.picture_src_preview,
    }
    this.application.apiService
      .updateClassItem(
        environment['gid'],environment['g_hash'],
        this.listItem ? this.listItem['itemFullData']['id'] : null,
        configToSave)
      .subscribe(
        data => {
          let notification = new FS3Notification();
          notification.type = 'success';
          notification.text = 'Group has been saved!';
          this.sharedDataService.pushNotification(notification);
          if(!this.payload['item']) { //append new item to list
            let listItem = this.application.apiService.extractCommunityClasses([data])[0];
            let appEvent = new AppEvent(AppEvent.COMMUNITY_CLASS_ADDED,{"listItem": listItem});
            this.sharedDataService.pushAppEvent(appEvent)
          } else {
            let listItem = this.application.apiService.extractCommunityClasses([data])[0];
            let appEvent = new AppEvent(AppEvent.COMMUNITY_CLASS_UPDATED,{"listItem": listItem});
            this.sharedDataService.pushAppEvent(appEvent)
          }
          this.success.emit()
        },
        error => {
          const { exception } = error;
          const errMsg = error['errMsg'] ? error['errMsg'] : (
            (exception && exception.error && exception.error.message) ? exception.error.message : 'Error'
          );
          let notification = new FS3Notification();
          notification.type = 'error';
          notification.text = errMsg;
          this.sharedDataService.pushNotification(notification);
          this.state = 'edit'
          this.validationResult = {
            isValid: false,
            message: errMsg
          };
        }
      )
  }

  private formValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const value = control.value.toString().replace(/ /g, '');
      if (!value) {
        return {required: this.formValidationMessages.required}
      }

      // if (isNaN(value*1) || parseFloat(value) != parseInt(value)) {
      //   return {onlyDigitsRequired: this.formValidationMessages.onlyDigitsRequired}
      // }
      //
      // if (Math.abs(control.value) > 9999) {
      //   return {maxValueForbidden: this.formValidationMessages.maxValueForbidden}
      // }

      return null;
    };
  }

  public onNoClick(): void {
    //this.dialogRef.close({ isConfirmed: false });
    this.close.emit()
  }

  public deleteClass(): void {
    // this.close.emit()
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      height: 'auto',
      data: {
        application: this,
        state: 'community-class-delete',
        payload: {
          //folderUUID: this.urlAfterRedirects.split('/')[3],
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((confirmed) => {
        if(confirmed) {
          this.state = 'loading';
          this.application.apiService
            .deleteClassItem(environment['gid'],environment['g_hash'],this.listItem['itemFullData']['id'])
            .subscribe(
              data => {
                let notification = new FS3Notification();
                notification.type = 'success';
                notification.text = 'Deleted!';
                this.sharedDataService.pushNotification(notification);
                let appEvent = new AppEvent(AppEvent.COMMUNITY_CLASS_DELETED,{"listItem": this.listItem});
                this.sharedDataService.pushAppEvent(appEvent)
                this.close.emit()
              },
              error => {
                this.state = 'edit';
                const { exception } = error;
                if (exception && exception.error && exception.error.message) {
                  let notification = new FS3Notification();
                  notification.type = 'error';
                  notification.text = exception.error.message;
                  this.sharedDataService.pushNotification(notification);
                }
              }
            )
        }
      })
  }

}
